<template>
    <transition name="modal">
        <div class="modal-mask">
            <div class="modal-wrapper">
                <div class="modal-container">

                    <div class="modal-header">
                        <slot name="header">
                            Filter Images
                        </slot>
                    </div>

                    <div class="modal-body">
                        <v-selectpage title="Filter" name="filer" id="filter" :data="fields" v-model="selectedFields"
                            key-field="id" show-field="name" placeholder="Select fields" :multiple="true"
                            class="overflow-auto w-32" language="en">
                        </v-selectpage>
                        <v-selectpage title="Status" name="status" id="status" :data="statusOptions" v-model="statusFilters"
                            key-field="id" show-field="name" placeholder="Select status filters"
                            class="overflow-auto w-32 mt-2" language="en">
                        </v-selectpage>
                        <v-selectpage title="Sort" name="sort" id="sort" :data="sortOptions" v-model="sortFilters"
                            key-field="id" show-field="name" placeholder="Select sort options" :multiple="true"
                            class="overflow-auto w-32 mt-2" language="en">
                        </v-selectpage>
                        <v-selectpage title="Sort by creation date" name="sort" id="sort" :data="directionOptions" v-model="sortDirections"
                            key-field="id" show-field="name" placeholder="Select sort direction"
                            class="overflow-auto w-32 mt-2" language="en">
                        </v-selectpage>
                    </div>

                    <div class="modal-footer">
                        <slot name="footer">
                            <button class="modal-button flex items-center text-white bg-woo hover:translate-x-0 hover:bg-hoverwoo py-1 px-3" @click="filter()">
                                Filter
                            </button>
                            <button class="modal-default-button flex items-center text-white bg-woo hover:translate-x-0 hover:bg-hoverwoo py-1 px-3" @click="$emit('close');">
                                Close
                            </button>
                        </slot>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>
<script>
export default {
    created() {
    },
    data() {
        return {
            selectedFields: this.currentFields,
            sortFilters: this.sortFilter,
            statusFilters: this.statusFilter,
            sortDirections: this.sortDirection,
        };
    },
    components: {
    },
    methods: {
        filter(){
            this.$emit('filterImages', this.selectedFields, this.sortFilters, this.statusFilters, this.sortDirections);
            this.$emit('close');
        }
    },
    props: {
        fields:Array,
        sortOptions:Array,
        statusOptions: Array,
        directionOptions: Array,
        currentFields: String,
        sortFilter: String,
        statusFilter:String,
        sortDirection:String,
    }
};
</script>
<style>
.modal-mask {
  position: fixed;
  z-index: 1;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  width: 40%;
  margin: 0px auto;
  padding:30px 80px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  font-family: Helvetica, Arial, sans-serif;
  display: flex;
  flex-direction: column;
}

.modal-header {
  margin-top: 20px 0;
  font-family: "Trebuchet MS", Arial, Helvetica, sans-serif;
  font-weight: 700;
  font-size: 1.3rem;
 
}
.modal-button {
    float:left;
}

.modal-body {
  margin: 20px 0;
  width: 100%;
  align-self: center;
}

.modal-default-button {
  float: right;
}


.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
div.v-dropdown-caller.v-dropdown-caller--full-width{
    width:100%;
}
</style>